import { useCallback } from 'react';
import type { VoidFunctionComponent } from 'react';

import { Action, ResourceType } from '../../../../../typings/permissions';
import { useDialogContext } from '../../../../contexts/DialogContext';
import { window } from '../../../../globals';
import * as api from '../../../../redux/api';
import Button, { BUTTON_TYPE } from '../../../generic/Button';
import Icon, { icons } from '../../../generic/Icon';
import type { Token } from '../../../../types';
import { PasswordInput } from '../../../generic';

type UserToken = Token & {
  userId: string;
  userName: string;
  userEmail: string;
  super: boolean;
};

type APITokenRowProps = {
  token: UserToken;
  index: number;
  showModal: (token?: UserToken) => void;
};

/**
 * @deprecated - Don't edit/add to this component if possible, as it has been replaced as part of GRANULAR_ORGANIZATION_SETTINGS and will soon be removed. See `app/componennts/settings/` for the new components.
 */
const APITokenRow: VoidFunctionComponent<APITokenRowProps> = ({
  token,
  index,
  showModal,
}) => {
  const { onConfirm } = useDialogContext();

  const deleteAPIToken = useCallback(async () => {
    await api.remove(`/api/user/${token.userId}/api_token`, {
      body: { token: token.token },
      json: true,
    });
    window.location.reload();
  }, [token]);

  return (
    <div className="api-token-table__row" key={`token_${index}`}>
      <div className="api-token-table__col" key={`token_${index}_name`}>
        {token.name}
      </div>
      <div className="api-token-table__col api-token-table__password" key={`token_${index}_token`}>
        <div className="api-token-table__password">
          <PasswordInput
            isDisabled
            label="token"
            value={token.token}
          />
        </div>
      </div>
      <div className="api-token-table__col margin-left-sm margin-right-sm" key={`token_${index}_type`}>
        {token?.meta?.pushOnly ? 'push-only' : 'full'}
      </div>
      {window.hasPermission({
        action: Action.Edit,
        resourceType: ResourceType.OrganizationIntegrationSettings,
      }) && (
        <div className="api-token-table__col margin-left-sm margin-right-sm" key={`token_${index}_username`}>
          {token.userName}
        </div>
      )}
      <div
        className="api-token-table__col__action-col margin-left-sm margin-right-sm"
        key={`token_${index}_edit`}
      >
        <Button
          isFullWidth
          type={BUTTON_TYPE.SECONDARY}
          onClick={() => {
            showModal(token);
          }}
        >
          <Icon icon={icons.pencil} />
        </Button>
      </div>
      <div
        className="api-token-table__col__action-col  margin-left-sm margin-right-sm"
        key={`token_${index}_delete`}
      >
        <Button
          isFullWidth
          type={BUTTON_TYPE.SECONDARY}
          onClick={() => {
            onConfirm({
              title: 'Confirm Token removal',
              body: (
                <div>
                  <p>
                    <b>Are you sure you want to delete this API token?</b> This
                    cannot be undone.
                  </p>
                </div>
              ),
              onConfirm: deleteAPIToken,
            });
          }}
        >
          <Icon icon={icons.times} />
        </Button>
      </div>
    </div>
  );
};

export default APITokenRow;
